export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f44138e434624fc2e647b9901c8c92f138b2da114&name=fetchTypeahead!'